import * as angular from "angular";
import {IController} from "angular";
import {FulfillmentPackageSplitType} from "../../types/fulfillment-package-split.type";

export class SplitPackagesDialogViewComponent implements IController {

  payload: any;
  fulfillmentSteps: any;
  packageItem: any;
  packageItemSettings: any;
  packageCount: number;
  packageWeight: number;
  selectedAction: string;
  weightUnit: string;
  distanceUnit: string;
  volumeUnit: string;
  executionStep: any;
  countToMove: number;
  maximumPackagesToMove: number;
  minimumWeightToMove: number;
  maximumWeightToMove: number;
  weightToMove: number;
  splitType: string;
  isSplitCountIntoMultipleSteps: boolean;
  isSplitWeightIntoMultipleSteps: boolean;
  weightPerLeg: number;
  multipleStepsWeightSplitCount: number;
  multipleStepsWeightSplitRemainder: number;
  originalStepWeightRemainder: number;
  onSelectAction: Function;
  onPayloadChange: Function;
  onSelectStep: Function;
  onSelectExecutionStep: Function;
  onChangeCount: Function;
  onChangeWeight: Function;
  onToggleCountPerLeg: Function;
  onToggleWeightPerLeg: Function;
  onWeightPerLegChange: Function;

  public fulfillmentPackageSplitType: typeof FulfillmentPackageSplitType = FulfillmentPackageSplitType;

  constructor(private splitService) {
  }

  $onInit() {
    this.weightUnit = this.splitService.getWeightUnit();
    this.distanceUnit = this.splitService.getSiteDistanceSmallUnit();
    this.volumeUnit = this.splitService.getVolumeUnit();
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('splitPackagesDialogView', {
    require: {
      form: '^form'
    },
    bindings: {
      payload: '<',
      fulfillmentSteps: '<',
      packageItem: '<',
      packageItemSettings: '<',
      packageCount: '<',
      packageWeight: '<',
      selectedAction: '<',
      executionStep: '<',
      countToMove: '<',
      weightToMove: '<',
      maximumPackagesToMove: '<',
      minimumWeightToMove: '<',
      maximumWeightToMove: '<',
      splitType: '<',
      isSplitCountIntoMultipleSteps: '<',
      isSplitWeightIntoMultipleSteps: '<',
      multipleStepsWeightSplitCount: '<',
      multipleStepsWeightSplitRemainder: '<',
      weightPerLeg: '<',
      originalStepWeightRemainder: '<',
      onSelectPackage: '&',
      onSelectAction: '&',
      onPayloadChange: '&',
      onSelectStep: '&',
      onSelectExecutionStep: '&',
      onChangeCount: '&',
      onChangeWeight: '&',
      onToggleCountPerLeg: '&',
      onToggleWeightPerLeg: '&',
      onWeightPerLegChange: '&'
    },
    template: require('./split-packages-dialog-view.html').default,
    controller: SplitPackagesDialogViewComponent
  });
